import { Container, injectable } from 'inversify'
import 'reflect-metadata'

import { watch } from 'vue';


import MyApolloClient from '../../../../common/infrastructure/funciones/HelperApolloClient';
import { dataUpdate } from '../domain/dataUpdate';
import { IDataUpdateRepository } from '../domain/IDataUpdateRepository';

import { UPDATE } from './mutation/updateDataMutation';
import HelperUtils from '../../../../common/infrastructure/funciones/HelperUtils';
import { DataUpdateResult } from '../domain/dataUpdateResult';



@injectable()
export class DataUpdateApolloClientRepository implements IDataUpdateRepository {
  private apolloClient : MyApolloClient
  private clientId: string;
  constructor (apolloInstance: MyApolloClient, clientId:string) {
    this.apolloClient = apolloInstance
    this.clientId=clientId
  }
  
  

  async update (applicationId:number, applicationVersion:number,componentId:number,componentDataSourceId:number,dataInput: dataUpdate[],transactionOperation:boolean): (Promise<DataUpdateResult[]>) {
    return new Promise<DataUpdateResult[]>(async (resolve, reject) => {
            const result = this.apolloClient.executeQuery(UPDATE,{applicationId: applicationId,applicationVersion:applicationVersion,componentId:componentId,componentDataSourceId:componentDataSourceId,data:dataInput,transactionOperation:transactionOperation},this.clientId)      
      watch(result, (value: any) => {
        
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.dataMutation.updateData)
        }
        catch(e) {
          reject()
        }
      });

    });
  }

}


